<script setup lang="ts">
  import { Icon } from '@/components';

  interface StarsProps {
    modelValue: number;
    stars?: number;
  }

  withDefaults(defineProps<StarsProps>(), {
    stars: 5,
  });
</script>

<script lang="ts">
  export default {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };
</script>

<template>
  <div class="tl-stars">
    <Icon
      v-for="star in stars"
      :key="star"
      name="star"
      size="xs"
      :class="[
        'tl-stars__icon',
        {
          'tl-stars__icon_filled': star <= modelValue,
        },
      ]"
      data-test-id="icon"
    />
  </div>
</template>

<style lang="scss" scoped>
  .tl-stars {
    align-items: center;
    display: flex;
    gap: var(--spacing-xxxs);

    &__icon {
      fill: none;
      stroke: var(--color-orange-40);

      &_filled {
        fill: var(--color-orange-40);
      }
    }
  }
</style>
